import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useEmailAttachmentCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess: (data: Api.IFileAttachment) => void;
	onError: (error: Error) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (file: File) => {
			const data = new FormData();
			data.append('file', file);
			return userSession.webServiceHelper.callAsync<Api.IFileAttachment>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `email/attachment` }),
				'POST',
				data
			);
		},
		onSuccess,
		onError,
	});
}
